<div
  *ngIf="visible"
  class="ai-analysis-in-progress-banner"
  [class.ai-analysis-in-progress-banner--compact]="compact"
  [class.ai-analysis-in-progress-banner--attention]="attentionStyle"
  [class.ai-analysis-in-progress-banner--error]="error"
  role="status"
>
  <i class="ri-error-warning-fill ai-analysis-in-progress-banner__icon" aria-hidden="true"></i>
  <div class="ai-analysis-in-progress-banner__message">
    <!-- innerHTML: every message here is one of our own i18n strings, some carrying bold emphasis. -->
    <span class="ai-analysis-in-progress-banner__text" [innerHTML]="displayMessageKey | translate"></span>
    <button
      *ngIf="showRefreshButton"
      type="button"
      class="ai-analysis-in-progress-banner__refresh"
      (click)="refresh()"
    >
      {{ 'button.refresh' | translate }}
    </button>
    <div *ngIf="progress" class="ai-analysis-in-progress-banner__progress">
      <mat-progress-bar
        class="ai-analysis-in-progress-banner__progress-bar"
        mode="determinate"
        [value]="progress.percentage"
      ></mat-progress-bar>
      <span class="ai-analysis-in-progress-banner__progress-count"> {{ progress.percentage }}% </span>
    </div>
  </div>
</div>
